import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

// this middleware throws exceptions if response status (casted to string) matches a regex
export const throwAPIErrorsMiddleware = (
  statusRegex: RegExp
): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  if (respOrError && !(respOrError instanceof Error)) {
    const { status } = respOrError
    if (statusRegex.test(status ? status.toString() : '')) {
      let text = ''
      try {
        text = await respOrError.text()
      } catch (e) {}
      const err = new Error(text || `${status} error`) as ErrorWithResponseType
      err.response = respOrError
      throw err
    }
  }
  return respOrError
}

export const throw400sMiddleware = throwAPIErrorsMiddleware(/4\d\d/)
export const throw500sMiddleware = throwAPIErrorsMiddleware(/5\d\d/)

export default throwAPIErrorsMiddleware
